import React from 'react';
import { Routes, Route } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';

import { FullPageLoader } from 'common';
import { SideMenu } from 'components/side-menu';
import { AppHeader } from 'components/headers/app';
import { AuthRoute, ProtectedRoute } from 'components/routes';

import { HeaderProvider } from 'providers/header';

import { AdminRoutes, AuthRoutes, ServiceRoutes } from './routes';

dayjs.extend(utc);
dayjs.extend(isoWeek);

function App() {
  return (
    <div className="app">
      <React.Suspense fallback={<FullPageLoader />}>
        <Routes>
          {AuthRoutes.map((item) => {
            return (
              <Route
                key={item.path}
                path={item.path}
                element={<AuthRoute>{item.element}</AuthRoute>}
              />
            );
          })}

          {ServiceRoutes.map((item) => {
            return (
              <Route
                key={item.path}
                path={item.path}
                element={<div className="main">{item.element}</div>}
              />
            );
          })}

          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <div className="main-wrapper">
                  <SideMenu />
                  <HeaderProvider>
                    <div className="main">
                      <div className="page-container">
                        <AppHeader />

                        <Routes>
                          {AdminRoutes.map((item) => {
                            return (
                              <Route
                                key={item.path}
                                element={item.element}
                                path={`${item.path}` + '/*'}
                              />
                            );
                          })}
                        </Routes>
                      </div>
                    </div>
                  </HeaderProvider>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </React.Suspense>
    </div>
  );
}

export default App;
